/** PURE_IMPORTS_START _Observable,_util_noop PURE_IMPORTS_END */
import { Observable } from '../Observable';
import { noop } from '../util/noop';
export var NEVER = /*@__PURE__*/ new Observable(noop);
export function never() {
    return NEVER;
}
//# sourceMappingURL=never.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/observable/never.js
// module id = 657
// module chunks = 0